<template>
  <div class="card-footer-item">
    <!-- <embed :src="pdfUrl" type="application/pdf" width="100%" height="600px" />
    <div v-if="summary">{{ summary }}</div> -->
    <!-- <input type="file" @change="onFileChange">
    <button @click="uploadFile" :disabled="!pdfFile">Upload</button>
    <div v-if="summary">{{ summary }}</div> -->
 
        <b-field class="file is-primary" :class="{'has-name': !!pdfFile}">
            <b-upload v-model="pdfFile" class="file-label" @change="onFileChange">
                <span class="file-cta">
                    <b-icon class="file-icon" icon="upload"></b-icon>
                    <span class="file-label">Datei auswählen</span>
                </span>
                <span class="file-name" v-if="pdfFile">
                    {{ pdfFile.name }}
                </span>
            </b-upload>
            <b-tooltip 
              label="Die Datei wird hochgeladen"
              position="is-bottom">
            <b-button :loading="loading" type="is-primary is-light" @click="uploadFile" :disabled="!pdfFile">Upload</b-button>
            </b-tooltip>
        </b-field>
        <!-- <div v-if="summary">{{ summary }}</div> -->
    </div>
 
</template>

<script>
// import axios from 'axios';
import { mapActions } from 'vuex';
/* import { default as pdfParse } from 'pdf-parse';
import openai from 'openai'; */

export default {
  data() {
    return {
      pdfFile: null,
      pdfUrl: '',
      summary: '',
      loading: false
    };
  },
  mounted() {
    //this.loadPDF();
  },
  methods: {
    ...mapActions(['uploadPDF', 'createPDF']),
    //write a method using ajax to load the pdf file

    onFileChange(event) {
      this.pdfFile = event.target.files[0];
    },
    async uploadFile() {
      const formData = new FormData();
      formData.append('file', this.pdfFile);

      try {
        this.loading = true
        // Upload the PDF file to the Strapi backend
        //const response = await this.$store.dispatch("uploadPDF", formData)

        const uploadResponse = await this.uploadPDF(formData);

        /*
        axios.post('http://localhost:1338/upload', formData, {
                  headers: { 'Content-Type': 'multipart/form-data' }
                });
        */

        // const fileId = response.data[0].id; // Retrieve the file ID from the response
        console.log("PdfSummarize.vue uploadFile()", uploadResponse)
        const uploadedFile = uploadResponse[0]
        console.log("uploadedFile", uploadedFile)
        // console.log("id --- ", fileId)

         // Dispatch the action to create a PDF entry with the uploaded file ID
         const createPDFResponse = await this.createPDF(uploadedFile.id);

         console.log("create PDF Response", createPDFResponse)
         
         this.loading = false
         alert('Datei wurde erfolgreich hochgeladen!');

         location.reload(this.$router.currentRoute);
         //const summaryResponse = await axios.post('http://localhost:1338/pdf-uploads', { id: fileId });

        // // Retrieve the summary from the response
        // this.summary = summaryResponse.data.summary;
      } catch (error) {
        this.loading = false
        console.error(error);
      }
    },

    // async loadPDF() {
    //   const response = await axios.get(this.pdfFile, { responseType: 'arraybuffer' });
    //   const pdfData = new Uint8Array(response.data);

    //   // Convert the PDF data to Base64 URL format
    //   const pdfBase64 = btoa(String.fromCharCode.apply(null, pdfData));
    //   this.pdfUrl = `data:application/pdf;base64,${pdfBase64}`;

    //   // Extract text from PDF
    //   const { text } = await pdfParse(pdfData);
    //   // Perform summarization using GPT
    //   const summary = await this.generateSummary(text);
    //   this.summary = summary;
    // },
    // async generateSummary(text) {
    //   const response = await openai.complete({
    //     engine: 'davinci',
    //     prompt: text,
    //     max_tokens: 100,
    //     temperature: 0.5,
    //     top_p: 1.0,
    //     frequency_penalty: 0.0,
    //     presence_penalty: 0.0,
    //   });

    //   return response.data.choices[0].text;
    // },
  },
};
</script>
